import React from "react";
import Faq from "react-faq-component";
import { useSelector } from "react-redux";
import { data } from "../components/DataHelp";
import Navbar from "../components/Navbar";
import "../styles/Help.css";

function Help() {
  const userToken = useSelector((state) => state.authReducer.token);
  return (
    <>
      {userToken ? <Navbar isAutenticated={userToken} /> : null}
      <div className="help">
        <Faq
          data={data}
          styles={{
            bgColor: "white",
            titleTextColor: "#fd8c22",
            rowTitleColor: "#071358",
            rowTitleTextSize: "large",
            rowContentColor: "black",
            rowContentTextSize: "16px",
            rowContentPaddingTop: "10px",
            rowContentPaddingBottom: "10px",
            rowContentPaddingLeft: "50px",
            rowContentPaddingRight: "150px",
            arrowColor: "black",
          }}
        />
      </div>
    </>
  );
}

export default Help;
